import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

const renderIcon = (IconComp, compact) => {
  if (!IconComp) {
    return null
  }

  const iconSize = compact ? 28 : 40
  const iconProps = {
    fontSize: iconSize,
    htmlColor: '#FFFFFF',
    style: { color: '#FFFFFF' },
  }

  if (typeof IconComp === 'function') {
    try {
      const rendered = IconComp()
      if (React.isValidElement(rendered)) {
        return React.cloneElement(rendered, {
          ...iconProps,
          style: { ...iconProps.style, ...rendered.props.style },
        })
      }
    } catch (error) {
      // IconComp is a component reference, not a render prop.
    }

    const Icon = IconComp
    return <Icon {...iconProps} />
  }

  const Icon = IconComp
  return <Icon {...iconProps} />
}

const SectionEmptyState = ({
  Icon,
  title,
  caption,
  action,
  bordered = true,
  compact = false,
}) => {
  const classes = useStyles()

  return (
    <Box
      className={`${classes.root} ${compact ? classes.compact : ''} ${
        bordered ? classes.bordered : ''
      }`}
    >
      {Icon ? (
        <Box
          className={`${classes.iconCircle} ${
            compact ? classes.iconCircleCompact : ''
          }`}
        >
          {renderIcon(Icon, compact)}
        </Box>
      ) : null}
      <Typography
        variant="h6"
        component="h2"
        className={`${classes.title} ${compact ? classes.titleCompact : ''}`}
      >
        {title}
      </Typography>
      {caption ? (
        <Typography
          variant="body2"
          className={`${classes.caption} ${
            compact ? classes.captionCompact : ''
          }`}
        >
          {caption}
        </Typography>
      ) : null}
      {action ? <Box className={classes.actions}>{action}</Box> : null}
    </Box>
  )
}

SectionEmptyState.propTypes = {
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType]),
  title: PropTypes.node.isRequired,
  caption: PropTypes.node,
  action: PropTypes.node,
  bordered: PropTypes.bool,
  compact: PropTypes.bool,
}

export default SectionEmptyState
